import { render } from "./RegisterIndividualUser.vue?vue&type=template&id=5662d7a3&scoped=true"
import script from "./RegisterIndividualUser.vue?vue&type=script&lang=js"
export * from "./RegisterIndividualUser.vue?vue&type=script&lang=js"

import "./RegisterIndividualUser.vue?vue&type=style&index=0&id=5662d7a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5662d7a3"]])

export default __exports__